import React, { ReactNode } from 'react'
import { Box } from '@node-space/ui-components'

export interface FormFieldsRowProps {
  leftField: ReactNode
  rightField: ReactNode
}

export const FormFieldsRow = ({ leftField, rightField }: FormFieldsRowProps) => {
  return (
    <Box flex gapX={12}>
      <Box width="full">{leftField}</Box>
      <Box width="full">{rightField}</Box>
    </Box>
  )
}
